(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["p-bildhinweis"] && !Shopify.designMode) return;
  try {
    (() => {
    const BOX = '.p-bildhinweis__box';

    /* Schrift so weit verkleinern, dass die breiteste Zeile in die Original-Box passt. Alle Maße laufen in cqi,
       das Verhältnis ist also größenunabhängig → einmal messen, sobald die Box sichtbar (Breite > 0) ist. */
    const fit = (box) => {
      const width = box.getBoundingClientRect().width;
      if (!width) return;
      box.style.removeProperty('--p-bh-fit');
      let widest = 0;
      box.querySelectorAll('.p-bildhinweis__line').forEach((line) => {
        widest = Math.max(widest, line.getBoundingClientRect().width);
      });
      if (widest > width) box.style.setProperty('--p-bh-fit', (width / widest).toFixed(4));
    };

    const observer = new ResizeObserver((entries) => entries.forEach((entry) => fit(entry.target)));
    const watch = (root) => {
      root.querySelectorAll?.(BOX).forEach((box) => {
        if (box.dataset.pBhFit) return;
        box.dataset.pBhFit = '1';
        observer.observe(box);
      });
    };

    const start = () => {
      watch(document);
      /* Galerie wird bei Variantenwechsel neu gerendert, Zoom-Dialog später befüllt */
      new MutationObserver((mutations) => {
        mutations.forEach((m) => m.addedNodes.forEach((node) => node.nodeType === 1 && watch(node)));
      }).observe(document.body, { childList: true, subtree: true });
      /* Webfont nachgeladen → Zeilenbreiten ändern sich */
      document.fonts?.ready.then(() => document.querySelectorAll(BOX).forEach(fit));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
